import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { finalize } from 'rxjs/operators';

import { DependenteService } from '@app/shared/services';
import { MensagemService } from '@app/shared/services/mensagem.service';
import { UtilService } from '@app/shared/services/util.service';

import { environment } from '@environments/environment';

import { Censo, Dependente, Loading, Segurado } from '@app/shared/models';
import { CensoService } from '@app/shared/services/censo.service';

@Component({
  selector: 'app-excluir-dependente',
  templateUrl: './excluir-dependente.component.html',
  styleUrls: ['./excluir-dependente.component.scss']
})
export class ExcluirDependenteComponent {

  carregar = new Loading();
  cliente = environment.cliente;

  form: FormGroup;
  dependente: Dependente;
  segurado: Segurado;
  censo: Censo;

  constructor(
    public dialogRef: MatDialogRef<ExcluirDependenteComponent>,
    private fb: FormBuilder,
    private dependenteService: DependenteService,
    private mensagemService: MensagemService,
    private utilService: UtilService,
    private censoService: CensoService,
    @Inject(MAT_DIALOG_DATA) public data: { dependente: Dependente, segurado: any,  }
  ) {
    this.censo = this.censoService.retornarSessionStorage('censo');
    this.dependente = data.dependente;
    this.segurado = data.segurado;

    this.form = this.fb.group({
      motivo: [null, Validators.required],
    });
  }

  salvar(): void {
    this.form = this.utilService.verificarForm(this.form);

    if (this.form.invalid) return this.mensagemService.avisoFormularioInvalido();

    this.carregar.load = true;

    this.dependenteService.delete(this.dependente.id, this.form.value)
      .pipe(finalize(() => this.carregar.load = false))
      .subscribe(() => {
        this.dialogRef.close(this.form.value);
        this.mensagemService.avisoMensagemApagado();
    });
  }
}
